module.exports = __webpack_public_path__ + "media/logos/cuk_logo_banner-1026ec16.png";